var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ability"},[_c('p',[_c('strong',[_vm._v(_vm._s(_vm.ability.name)+":")]),_vm._v(" "),_c('i',[_vm._v(_vm._s(_vm.ability.description))])]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.ability.effect)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dad10a2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Ability.vue
// module id = null
// module chunks = 